import React from "react";

import { OverlayTrigger, Popover } from "react-bootstrap";
import { Button, ButtonGroup } from "aible";

import AibleStep from "containers/CreateWizard/AibleStep";
import Models from "containers/CurrentState/Models";

import { isEnabled } from "utils/featureFlags";

import Auditable from "images/auditable.svg";
import HumanUnderstandable from "images/human_understandable.svg";

import styles from "./style.module.css";

export default class ChooseOptions extends React.PureComponent {
  state = {
    hoverText: undefined
  };

  render() {
    const {
      id,
      label,
      isShow,
      humanUnderstandable,
      auditable,
      options,
      realTimeResults,
      useModelList,
      updateUseModelList,
      updateHumanUnderstandable,
      updateAuditable,
      updateRealTimeResults
    } = this.props;
    const { hoverText } = this.state;

    const isLocked = options && options["lock"];

    return (
      <div className={styles.body} style={{ opacity: isShow ? 1 : 0 }}>
        <AibleStep
          id={id}
          bId="chooseOptions"
          message={"Are there any business needs that your AI must support?"}
          secondaryMessage={
            "Auditable AI provides the transparency required for regulated industries. " +
            "Human-Understandable AI allows you to understand the drivers of a prediction and take specific " +
            "actions to improve the outcome."
          }
          isBreak={true}
        >
          <div className={styles.oHolder}>
            <div className={styles.buttonHolder}>
              {isEnabled("advanced-model-selection") && false && (
                <Button type="secondary" onClick={() => updateUseModelList(!useModelList)}>
                  {useModelList ? "Hide Advanced" : "Show Advanced"}
                </Button>
              )}
            </div>
            {useModelList ? (
              <Models id={id} />
            ) : (
              <div className={styles.checkboxHolder}>
                <div className={styles.hoverText} style={{ opacity: hoverText === undefined ? 0 : 1 }}>
                  {hoverText}
                </div>
                <Button
                  type="secondary"
                  active={humanUnderstandable === false && auditable === false && realTimeResults === false}
                  style={{ marginRight: "15px" }}
                  onClick={
                    isLocked
                      ? () => {}
                      : () => {
                          updateHumanUnderstandable(false);
                          updateAuditable(false);
                          updateRealTimeResults(false);
                        }
                  }
                >
                  {"No Restrictions"}
                </Button>
                <ButtonGroup>
                  <OverlayTrigger
                    placement="top"
                    trigger={["hover", "focus"]}
                    overlay={
                      <Popover id="popover-positioned-top">
                        {"Auditable AI provides the transparency required for regulated industries."}
                      </Popover>
                    }
                  >
                    <Button
                      type="secondary"
                      active={auditable}
                      onClick={() => !isLocked && updateAuditable(!auditable)}
                    >
                      <img src={Auditable} className={styles.imgIcon + " " + (auditable ? styles.isActive : "")} />
                      {"Auditable"}
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    trigger={["hover", "focus"]}
                    overlay={
                      <Popover id="popover-positioned-top">
                        {"Human-Understandable AI allows you to understand the drivers of" +
                          " a prediction and take specific actions to improve the outcome."}
                      </Popover>
                    }
                  >
                    <Button
                      type="secondary"
                      active={humanUnderstandable}
                      onClick={() => !isLocked && updateHumanUnderstandable(!humanUnderstandable)}
                    >
                      <img src={HumanUnderstandable} className={styles.imgIcon} />
                      {"Human-Understandable"}
                    </Button>
                  </OverlayTrigger>
                </ButtonGroup>
                {/*<span>
              <input
                type="checkbox"
                style={{ marginRight: '10px', marginBottom: '2px' }}
                checked={allAiTypes}
                onChange={() => {
                  if (allAiTypes === false) {
                    this.setState({
                      humanUnderstandable: false,
                      auditable: false,
                      realTimeResults: false
                    });
                  }

                  this.setState({ allAiTypes: !allAiTypes });
                }}
              />
              {'Consider all AI types for best ROI (least restrictive option)'}
            </span>
            <span>
              <input
                type="checkbox"
                style={{ marginRight: '10px', marginBottom: '2px' }}
                checked={humanUnderstandable}
                onChange={() => {
                  if (humanUnderstandable === false) {
                    this.setState({ allAiTypes: false });
                  }

                  this.setState({
                    humanUnderstandable: !humanUnderstandable
                  });
                }}
              />
              {'My AI needs to be Human-Understandable (such as AI used for assigning credit rating or hiring)'}
            </span>
            <span>
              <input
                type="checkbox"
                style={{ marginRight: '10px', marginBottom: '2px' }}
                checked={auditable}
                onChange={() => {
                  if (auditable === false) {
                    this.setState({ allAiTypes: false });
                  }

                  this.setState({ auditable: !auditable });
                }}
              />
              {'My AI needs to be Auditable (such as AI used for financial models)'}
            </span>
            <span>
              <input
                type="checkbox"
                style={{ marginRight: '10px', marginBottom: '2px' }}
                checked={realTimeResults}
                onChange={() => {
                  if (realTimeResults === false) {
                    this.setState({ allAiTypes: false });
                  }

                  this.setState({
                    realTimeResults: !realTimeResults
                  });
                }}
              />
              {'My AI needs to generate results in Real-Time (e.g. AI used for customer service applications)'}
            </span>*/}
              </div>
            )}
          </div>
        </AibleStep>
      </div>
    );
  }
}
